import React from 'react'
import PropTypes from 'prop-types'
import { TableContainer, Table, TableBody, TableRow, TableCell } from '@mui/material'

const PrintSummaryInfo = ({ summaryInfo }) => (
  <>
    <TableContainer sx={{ overflow: 'hidden' }}>
      <Table size="small">
        <TableBody>
          {summaryInfo.map((row, index) => (
            <TableRow key={row.label}>
              <TableCell
                sx={{ pr: 0, pb: 0, fontWeight: index === 0 ? 700 : 'unset', borderBottom: 'none' }}
                align="right"
              >
                {row.label}
              </TableCell>
              <TableCell
                sx={{ pl: 1, pb: 0, fontWeight: index === 0 ? 700 : 'unset', borderBottom: 'none' }}
                align="right"
              >
                {row.value}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  </>
)

PrintSummaryInfo.propTypes = {
  summaryInfo: PropTypes.array.isRequired,
}

export default PrintSummaryInfo
